module.exports = __webpack_public_path__ + "img/women_dancing.7cebf63b.jpg";